export default __webpack_public_path__ + "static/media/1538.81b4708b.png";